// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#top-bar {
  display: grid;
  grid-template-columns: 40px 200px 75px 8px 75px 8px 40px 40px 40px 40px 40px 40px 40px 40px 1fr 40px;
  grid-template-rows: 100%;
}
#top-bar .disabled {
  opacity: 20%;
  pointer-events: none;
}
#top-bar #top-bar-logo {
  grid-row: 1;
  grid-column: 1;
}
#top-bar #top-bar-parent-name {
  grid-row: 1;
  grid-column: 2;
  font-family: "acumin-pro-condensed";
  font-size: 15pt;
  color: white;
  display: grid;
  align-content: center;
  padding-bottom: 5px;
}
#top-bar #key-frame {
  grid-row: 1;
  grid-column: 3;
  height: 24px;
  display: grid;
  align-self: center;
}
#top-bar #key-value {
  grid-row: 1;
  grid-column: 5;
  height: 24px;
  display: grid;
  align-self: center;
}
#top-bar #new-key {
  grid-row: 1;
  grid-column: 7;
}
#top-bar #frame-canvas {
  grid-row: 1;
  grid-column: 8;
}
#top-bar #flatten-tangent {
  grid-row: 1;
  grid-column: 9;
}
#top-bar #linear-tangent {
  grid-row: 1;
  grid-column: 10;
}
#top-bar #break-tangent {
  grid-row: 1;
  grid-column: 11;
}
#top-bar #unify-tangent {
  grid-row: 1;
  grid-column: 12;
}
#top-bar #step-tangent {
  grid-row: 1;
  grid-column: 13;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/tabs/propertyGrids/animations/curveEditor/scss/topBar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oGAAA;EACA,wBAAA;AACJ;AACI;EACI,YAAA;EACA,oBAAA;AACR;AAEI;EACI,WAAA;EACA,cAAA;AAAR;AAGI;EACI,WAAA;EACA,cAAA;EACA,mCAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AADR;AAII;EACI,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAFR;AAKI;EACI,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAHR;AAMI;EACI,WAAA;EACA,cAAA;AAJR;AAOI;EACI,WAAA;EACA,cAAA;AALR;AAQI;EACI,WAAA;EACA,cAAA;AANR;AASI;EACI,WAAA;EACA,eAAA;AAPR;AAUI;EACI,WAAA;EACA,eAAA;AARR;AAWI;EACI,WAAA;EACA,eAAA;AATR;AAYI;EACI,WAAA;EACA,eAAA;AAVR","sourcesContent":["#top-bar {\r\n    display: grid;\r\n    grid-template-columns: 40px 200px 75px 8px 75px 8px 40px 40px 40px 40px 40px 40px 40px 40px 1fr 40px;\r\n    grid-template-rows: 100%;\r\n\r\n    .disabled {\r\n        opacity: 20%;\r\n        pointer-events: none;\r\n    }\r\n\r\n    #top-bar-logo {\r\n        grid-row: 1;\r\n        grid-column: 1;\r\n    }\r\n\r\n    #top-bar-parent-name {\r\n        grid-row: 1;\r\n        grid-column: 2;\r\n        font-family: \"acumin-pro-condensed\";\r\n        font-size: 15pt;\r\n        color: white;\r\n        display: grid;\r\n        align-content: center;\r\n        padding-bottom: 5px;\r\n    }\r\n\r\n    #key-frame {\r\n        grid-row: 1;\r\n        grid-column: 3;\r\n        height: 24px;\r\n        display: grid;\r\n        align-self: center;\r\n    }\r\n\r\n    #key-value {\r\n        grid-row: 1;\r\n        grid-column: 5;\r\n        height: 24px;\r\n        display: grid;\r\n        align-self: center;\r\n    }\r\n\r\n    #new-key {\r\n        grid-row: 1;\r\n        grid-column: 7;\r\n    }\r\n\r\n    #frame-canvas {\r\n        grid-row: 1;\r\n        grid-column: 8;\r\n    }\r\n\r\n    #flatten-tangent {\r\n        grid-row: 1;\r\n        grid-column: 9;\r\n    }\r\n\r\n    #linear-tangent {\r\n        grid-row: 1;\r\n        grid-column: 10;\r\n    }\r\n\r\n    #break-tangent {\r\n        grid-row: 1;\r\n        grid-column: 11;\r\n    }\r\n\r\n    #unify-tangent {\r\n        grid-row: 1;\r\n        grid-column: 12;\r\n    }\r\n\r\n    #step-tangent {\r\n        grid-row: 1;\r\n        grid-column: 13;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
